import toast from "react-hot-toast";
import * as api from "../Api";
import { errorMessage, loadFailed } from "../utils/errorMessage";

// create a  new asset
export const getLocation = () => async (dispatch) => {
  try {
    const { data } = await api.fetchLocations();
    dispatch({ type: "FETCH_ALL_LOCATION", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};

export const createLocation = (postData) => async (dispatch) => {
  let creatingIdCatId;

  try {
    creatingIdCatId = toast.loading("Creating Location...");
    const { data } = await api.CompanyLocation(postData);
    dispatch({ type: "CREATE_LOCATION", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Location created successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};

export const deleteLocation = (id) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Deleting location...");
    await api.deleteLocation(id);
    dispatch({ type: "DELETE_LOCATION", payload: id });
    toast.remove(creatingIdCatId);
    toast.success("Location deleted successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};

export const updateLocation = (id, postData) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Updating location...");
    const { data } = await api.updateLocation(id, postData);
    dispatch({ type: "UPDATE_LOCATION", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Location updated successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(errorMessage(error));
  }
};
